/**
 * Endpoint clients del maestro de artículos:
 *   - `/api/productos/buscar?sku=...`         → ficha completa.
 *   - `/api/productos/listar?sku=&nombre=`    → filtro del maestro.
 */

import {
  ProductoBuscarResponse,
  ProductoListarResponse,
  type ProductoBuscar,
  type ProductoListar,
} from '@/api/contracts/producto-acsis';
import { apiFetch } from '@/api/http';

export async function buscarProductoPorSku(sku: string): Promise<ProductoBuscar> {
  const data = await apiFetch<unknown>(
    `/productos/buscar?sku=${encodeURIComponent(sku)}`,
    { auth: true },
  );
  return ProductoBuscarResponse.parse(data);
}

/**
 * Filtra el maestro de artículos. Los dos criterios se combinan con AND en el
 * back; mandamos solo los que tienen contenido.
 */
export async function listarProductos(params: {
  sku?: string;
  nombre?: string;
}): Promise<ProductoListar> {
  const qs = new URLSearchParams();
  if (params.sku?.trim()) qs.set('sku', params.sku.trim());
  if (params.nombre?.trim()) qs.set('nombre', params.nombre.trim());
  const data = await apiFetch<unknown>(`/productos/listar?${qs.toString()}`, {
    auth: true,
  });
  return ProductoListarResponse.parse(data);
}
